import { notification } from 'antd';

const showWarningNotification = (
	title: string,
	description?: string | React.ReactElement,
	duration: number = 2,
) => notification.warning({
	message: title,
	description,
	duration,
});

export default showWarningNotification;
